import { Component, OnInit } from '@angular/core';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {StorageService} from '../../../services/rest-api/storage.service';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-degrees',
  templateUrl: './degrees.component.html',
  styleUrls: ['./degrees.component.scss']
})
export class DegreesComponent implements OnInit {

  degreeData: any[] = [];
  departmentData: any[] = [];

  private deptId: number = 0;

  constructor(
    private _info: InfoApiService,
    private _actRoute: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private seo: SeoService
  ) {
    this._actRoute.paramMap.subscribe(params => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.deptId = this._actRoute.snapshot.params.id;
    this.getDegreesByDept(this.deptId);
    this.getDepartments();
    this.seo.setMeta('Degrees & Courses - Faculty of Humanities and Social Sciences');
  }

  navigatePage(current: string, param?: number) {
    if (current === 'home') {
      this.router.navigate(['/home']);

    } else if (current === 'department') {
      this.router.navigate(['/department/'+param]);

    }else if (current === 'degreedet') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };

      this.router.navigate(['/degreedet/'],navigationExtras);
    }
  }

  // View degrees by department id
  getDegreesByDept(deptId: number){
    this._info.getDegreesByDept(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.degreeData = response.body;
        this.storage.setdata('deptDegreeData',this.degreeData);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;

      }
    );
  }

  // Get departments
  getDepartments(){
    this._info.getDepartments().subscribe (
      (response: HssResponse<any>) => {
        this.departmentData = response.body;

      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;

      }
    );
  }
}
